import styled from 'styled-components';
import COLORS from '../../../utils/colors.constants';
const Subtitle = styled.h2`
font-family: Roboto, sans-serif;
font-size: 0.8em;
color : ${COLORS.AZUL};
`;

export default Subtitle;